import React from 'react';
import { connect } from "react-redux";

import { setPreferredBand } from '../../redux/actions/user';
import { getAuthJSON, RequestError } from '../../util/util';
import { GlobalState, ReduxAction } from '../../redux/types';
import { Band, BravoUser } from '../../bravoTypes';
import { urls } from '../../constants';
import { URLjoin } from '../../util/url';
import withAuth from './withAuth';
import { setBand } from '../../redux/actions/band';
import './contextProviders.css';

// Wrapping a component in `Authorized` will force the user to the login page, 
// with the appropriate referrer, if the user has not authenticated. 

type wrapperProps = {
    token?: string | null;
    profile?: BravoUser;
    preferredBand?: string | null;
    band?:Band
    updatePreferredBand: (preferredBand: string ) => void;
    setBand: (band: Band) => void;
};

type BandState = {
    band?:Band;
    bandError?: string | string[];
};

export type BandProps = {
    preferredBand?: string | null;
    band?:Band;
    updatePreferredBand: (preferredBand: string ) => void;
}


const mapStateToProps = (state:GlobalState) => ({
    preferredBand: state.user.preferredBand,
    band: state.band.band
});

const mapDispatchToProps = (dispatch:(a:ReduxAction)=>void) => ({
    updatePreferredBand: (preferredBand:string) => dispatch(setPreferredBand(preferredBand)),
    setBand: (band:Band) => dispatch(setBand(band))
});

export default function withBand(WrappedComponent: typeof React.Component, requireAuth=true) {
    class BandWrapper extends React.Component<wrapperProps, BandState> {
        constructor(props:wrapperProps) {
            super(props);
            const {profile, preferredBand, updatePreferredBand} = props;

            this.refreshPreferredBand = this.refreshPreferredBand.bind(this);


            let selectedPreferredBand = preferredBand;
            if(profile !== undefined){
                if(preferredBand === undefined || preferredBand === null){
                    const authBands = this.authorizedBands(profile);
                    if(authBands.length > 0){
                        updatePreferredBand(authBands[0]);
                        selectedPreferredBand = authBands[0];
                    }
                }
                
            }

        }

        async refreshPreferredBand(){
            const { preferredBand, token, setBand } = this.props;
            if(preferredBand && token){
                await getAuthJSON<Band>(URLjoin([urls.bravo.bands, preferredBand]), token).then(band=>{
                    if(band){
                        setBand(band);
                    }
                }).catch((reason:RequestError<undefined>) => {/**Don't care. */});
            }
        }

        componentDidUpdate(){
            const { preferredBand, band } = this.props;
            if(band === undefined || band.id !== preferredBand){
                console.log("Refreshing band!");
                
                this.refreshPreferredBand();
            }
        }

        authorizedBands(profile:BravoUser){
            let authBands:string[] = [];
            if (profile !== undefined){
                if(Array.isArray(profile.ownedBands)){
                    profile.ownedBands.forEach(band => {
                        if (band.id !== undefined && !authBands.includes(band.id)){
                            authBands.push(band.id);
                        }
                    });
                }
                if(Array.isArray(profile.managedBands)){
                    profile.managedBands.forEach(band => {
                        if (band.id !== undefined && !authBands.includes(band.id)){
                            authBands.push(band.id);
                        }
                    });
                }
            } 
 
            return authBands;
            
        }

        render() {
            const { preferredBand, updatePreferredBand, token, profile, band, setBand, ...props} = this.props;
            const loadingGif = <div id="loading" className="w-50 h-50"></div>
            if (token && profile && preferredBand && !band) {
                return loadingGif;
            } else {
                return <WrappedComponent {...{token, profile, preferredBand, band, updatePreferredBand, ...props}} refreshBand={this.refreshPreferredBand} />
            }
        }
    }
    return connect(mapStateToProps, mapDispatchToProps)(withAuth(BandWrapper, requireAuth));
};

